import {
    Bot,
    ClipboardCheck,
    Globe,
    MessageSquare,
    Phone,
    Repeat,
    Workflow,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import useReveal from "@/hooks/useReveal";
import { services } from "@/lib/offers";

const icons = {
    Globe,
    MessageSquare,
    Workflow,
    Repeat,
    Phone,
    Bot,
    ClipboardCheck,
};

function Cap({ item, i }) {
    const { ref, visible } = useReveal({ threshold: 0.15 });
    const navigate = useNavigate();
    const Icon = icons[item.icon] || Globe;
    return (
        <button
            type="button"
            ref={ref}
            onClick={() => navigate(`/services?tab=${item.slug}`)}
            style={{ transitionDelay: `${(i % 4) * 70}ms` }}
            className={`reveal group relative overflow-hidden rounded-3xl bg-white p-6 text-left ring-1 ring-black/5 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_44px_rgba(43,80,255,0.14)] hover:ring-[var(--brand)]/25 ${
                visible ? "is-visible" : ""
            }`}
        >
            <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[var(--brand-soft)] text-[var(--brand)] transition-colors group-hover:bg-[var(--brand)] group-hover:text-white">
                <Icon className="h-6 w-6" />
            </span>
            <p className="mt-4 text-xs font-semibold uppercase tracking-wide text-[var(--brand)]">{item.price}</p>
            <h3 className="mt-1 font-display text-lg font-bold text-[#0a0a0b]">{item.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-[#5b5b66]">{item.short}</p>
        </button>
    );
}

export default function Capabilities() {
    const { ref, visible } = useReveal();
    return (
        <section id="services" data-testid="services-section" className="bg-[#f6f7fb] px-5 py-16 sm:py-20">
            <div className="mx-auto max-w-5xl">
                <div ref={ref} className={`reveal mb-10 max-w-2xl ${visible ? "is-visible" : ""}`}>
                    <span className="rounded-full bg-white px-3 py-1 text-xs font-semibold uppercase tracking-wide text-[var(--brand)] ring-1 ring-black/5">
                        Services
                    </span>
                    <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight text-[#0a0a0b] sm:text-4xl">
                        Seven lines. One revenue system.
                    </h2>
                    <p className="mt-3 text-[15px] leading-relaxed text-[#5b5b66]">
                        Live SKUs where we have them. Custom work after the diagnostic. Open a tab for features,
                        deliverables, process, and limits.
                    </p>
                </div>
                <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                    {services.map((item, i) => (
                        <Cap key={item.slug} item={item} i={i} />
                    ))}
                </div>
            </div>
        </section>
    );
}
